// extracted by mini-css-extract-plugin
module.exports = {"Board":"Board_Board__3oaQH","BoardContent":"Board_BoardContent__3T6Rw","ArrowBack":"Board_ArrowBack__3bZyc"};